import { trackContentEngagement } from '../../js/front/analytics';

const ROOT_SELECTOR = '[data-js="lotto-prizes-odds"]';
const DEFAULT_VISIBLE_ROWS = 3;
const TOGGLE_SELECTOR = '[data-role="prizes-odds-toggle"]';
const TABLE_ROW_SELECTOR = '.b-lotto-game-prizes-odds__table-wrapper tbody tr';

/**
 * Set hidden state for a list of rows.
 *
 * @param {HTMLElement[]} rows Rows to update.
 * @param {boolean} hidden Target hidden state.
 * @return {void}
 */
const setRowsHidden = ( rows, hidden ) => {

	rows.forEach( ( row ) => {

		row.hidden = hidden;

	} );

};

/**
 * Toggle collapsed rows for a single block instance.
 *
 * @param {HTMLElement} root Block root element.
 * @return {void}
 */
const initBlock = ( root ) => {

	const toggle = root.querySelector( TOGGLE_SELECTOR );
	if ( ! toggle ) {

		return;

	}

	const initialVisibleRows = parseInt( root.dataset.initialVisibleRows, 10 ) || DEFAULT_VISIBLE_ROWS;
	const rows = [ ...root.querySelectorAll( TABLE_ROW_SELECTOR ) ].slice( initialVisibleRows );

	if ( ! rows.length ) {

		toggle.hidden = true;
		return;

	}

	setRowsHidden( rows, true );

	// Button text content takes priority; data-show-all-label is the fallback
	// for cases where the button text was cleared or not yet rendered.
	const fallbackLabel = toggle.textContent.trim();
	const showAllLabel = fallbackLabel || toggle.dataset.showAllLabel || '';
	const showLessLabel = toggle.dataset.showLessLabel || fallbackLabel;
	let isExpandTracked = false;

	toggle.addEventListener( 'click', () => {

		const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
		const nextExpanded = ! isExpanded;

		setRowsHidden( rows, ! nextExpanded );

		if ( nextExpanded && ! isExpandTracked ) {

			isExpandTracked = true;
			trackContentEngagement( root, 'prizes_odds_expand', 'show_all_button' );

		}

		toggle.setAttribute( 'aria-expanded', String( nextExpanded ) );
		toggle.textContent = nextExpanded ? showLessLabel : showAllLabel;

	} );

};

/**
 * Initialize all block instances on page.
 *
 * @return {void}
 */
const init = () => {

	document.querySelectorAll( ROOT_SELECTOR ).forEach( initBlock );

};

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', init );

} else {

	init();

}
